<template>
  <div>
    <calendar-box>
      <template #header>
        <a-button
          v-if="canExportSlotReport"
          size="large"
          class="align-right"
          @click="openSlotReportModal"
        >
          Pobierz raport godzin
        </a-button>
      </template>

      <template #calendar>
        <a-spin :spinning="loading">
          <div class="spin-content">
            <calendar
              :on-event-click="onEventClick"
              @cell-click="onCellClick"
              @ready="viewChanged"
              @view-change="viewChanged"
              :events="events"
              :min-date="minDate"
            >
              <template v-slot:title="{ view }">
                <span v-if="view.id === 'week'">
                  {{ view.startDate.format('MMMM') }}
                  {{ view.startDate.format('YYYY') }}
                  (Tydzień {{ view.startDate.getWeek() }})
                </span>
              </template>

              <template v-slot:weekday-heading="{ heading }">
                <span>
                  {{ formatDay(heading.date) }}
                  <strong>{{ heading.date.format('D.MM') }}</strong>
                </span>
              </template>

              <template v-slot:event="{ event }">
                <calendar-slot :event="event" />
              </template>
            </calendar>
          </div>
        </a-spin>
        <availability-modal ref="availabilityModal" @submit="fetchSlots" />
        <slot-modal
          ref="slotModal"
          @reserve="openReservationModal"
          @calendarChanged="closeModalsAndFetchSlots"
        />
        <reservation-modal ref="reservationModal" @submit="fetchSlots" />
        <slot-report-modal ref="slotReportModal" />
      </template>
    </calendar-box>
  </div>
</template>

<script>
import Calendar from '@/components/calendar/'
import CalendarBox from '@/components/calendar/CalendarBox'
import moment from 'moment'
import CalendarSlot from '@/components/calendar/CalendarSlot'
import Stats from '@/components/Stats/'
import AvailabilityModal from '@/components/modals/AvailabilityModal/'
import ReservationModal from '@/components/modals/ReservationModal/'
import SlotModal from '@/components/modals/SlotModal/'
import SlotReportModal from '@/components/modals/SlotReportModal/'
import { Slot } from '@/api'
import { isDate } from 'lodash'

export default {
  data() {
    return {
      loading: false,
      slots: [],
      startDate: null,
      endDate: null,
      events: []
    }
  },
  components: {
    Calendar,
    CalendarBox,
    SlotReportModal,
    // eslint-disable-next-line
    Stats,
    CalendarSlot,
    ReservationModal,
    AvailabilityModal,
    SlotModal
  },
  methods: {
    fetchSlotFromQueryAndOpenModal(slotId) {
      Slot.get(slotId)
        .then(res => {
          this.openSlotModal(res.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModalsAndFetchSlots() {
      if (this.$refs.slotModal) {
        this.$refs.slotModal.closeModal()
      }
      this.fetchSlots()
    },
    fetchSlots() {
      this.loading = true
      const params = {
        ...this.slotFilterParams,
        merge_slots: true
      }
      Slot.fetch({}, { params })
        .then(res => {
          this.events = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openReservationModal({ slotId, studentId, courseId, lecturerId, date }) {
      this.$refs.reservationModal.openModal({
        availabilitySlotId: slotId,
        lecturerId,
        studentId,
        courseId,
        date
      })
    },
    onEventClick(event, e) {
      e.stopPropagation()
      this.openSlotModal(event)
    },
    openSlotModal(event) {
      this.$refs.slotModal.openModal(event.id)
    },
    openSlotReportModal() {
      this.$refs.slotReportModal.openModal(this.selectedLecturer)
    },
    openReservationConfirmModal() {},
    onCellClick(event) {
      const dateClicked = isDate(event) ? event : undefined

      if (dateClicked && moment(event).isBefore(moment())) {
        this.$message.error('Nie można dodać dostępności, dla przeszłych dat.')
        return
      }
      this.$refs.availabilityModal.openModal(
        dateClicked,
        this.$route.params.lecturerId
      )
    },
    viewChanged(event) {
      this.startDate = event.startDate
      this.endDate = event.endDate
      this.fetchSlots()
    },
    formatDay(date) {
      const weekDays = ['Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.', 'Niedz.']
      return weekDays[date.format('d') - 1]
    }
  },
  computed: {
    minDate() {
      return new Date()
    },
    canExportSlotReport() {
      return this.selectedLecturer && this.isAdmin
    },
    selectedLecturer() {
      return this.$route.params.lecturerId
    },
    slotFilterParams() {
      return {
        availability__lecturer: this.$route.params.lecturerId,
        student: this.$route.params.studentId,
        related_course: this.$route.params.courseId,
        timespan_after: this.getDateOnly(this.startDate),
        timespan_before: this.getDateOnly(this.endDate)
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          if (value.query.slotId) {
            this.setQueryParam('slotId', undefined)
            this.fetchSlotFromQueryAndOpenModal(value.query.slotId)
          }
          if (value.query.reservationId) {
            this.setQueryParam('reservationId', undefined)
            this.openReservationConfirmModal(value.query.reservationId)
          }
        })
      }
    }
  }
}
</script>
